export default  {
    bindings: {
        option: '<',
        treatments: '<',
        formTab: '='
    },
    controller: 'optionsFormController',
    template: require('../views/options.form.html')
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/options.form.component.js